export const normalizeProps = props => {
  const { color, size, ...rest } = props

  return {
    ...(size && { width: size, height: size }),
    ...(color && { color: color }),
    ...rest,
  }
}
